<template>
  <div class="multi-column">
    <column
      v-for="singleColumn in columns"
      :key="singleColumn.id"
      class="multi-column__item"
      :title="singleColumn.title"
      :copy="singleColumn.copy"
      :image="getImage(singleColumn)"
    />
  </div>
</template>

<script>
// @todo: load data from contentful

import Column from './Column.vue';

export default {
  components: {
    Column,
  },
  props: ['data'],
  methods: {
    getImage(column) {
      return column.image ? column.image.fields.file : {};
    },
  },
  computed: {
    columns() {
      const { isColumnsLoading, isPageLoading, columns } = this.$store.state;

      return !isColumnsLoading && !isPageLoading
        ? this.data.columns
          .map((column) => columns
            .find((stateColumn) => stateColumn.id === column.sys.id))
        : [];
    },
  },
};
</script>

<style scoped>
.multi-column {
  display: flex;
  width: 100%;
  padding: 48px 0 0 0;
  flex-flow: wrap;
  justify-content: space-around;
}
.multi-column__item {
  max-width: 100%;
  background-color: var(--very-light);
  margin-bottom: 48px;
}

@media screen and (min-width: 640px) {
  .multi-column__item {
    max-width: 36%;
  }
}
</style>
